/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function customControllerQuery(requestId?: string): DataServiceQuery {
    const key = requestId ? { RequestId: requestId } : null;
    return new DataServiceQuery('CustomController', 'FUSCustomEntity', DataServiceEntities.FUSCustomEntityExtensionClass, key);
}

export function createSendRegistratonDataInput(
    fName: string,
    lName: string,
    email: string,
    phone: string,
    productType: string,
    productName: string,
    storeName: string,
    purchDate: string,
    mDate: string,
    itemId: string,
    batchId: string,
    serialId: string,
    reOrderCode: string,
    custAccount: string
): IDataServiceRequest {
    const query = customControllerQuery();
    return query.createDataServiceRequestForOperation(
        'SendRegistratonData',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            FName: fName,
            LName: lName,
            Email: email,
            Phone: phone,
            ProductType: productType,
            ProductName: productName,
            StoreName: storeName,
            PurchDate: purchDate,
            MDate: mDate,
            ItemId: itemId,
            BatchId: batchId,
            SerialId: serialId,
            ReOrderCode: reOrderCode,
            CustAccount: custAccount
        }
    );
}

export function sendRegistratonDataAsync(
    context: IContext,
    fName: string,
    lName: string,
    email: string,
    phone: string,
    productType: string,
    productName: string,
    storeName: string,
    purchDate: string,
    mDate: string,
    itemId: string,
    batchId: string,
    serialId: string,
    reOrderCode: string,
    custAccount: string
): AsyncResult<boolean> {
    const request = createSendRegistratonDataInput(
        fName,
        lName,
        email,
        phone,
        productType,
        productName,
        storeName,
        purchDate,
        mDate,
        itemId,
        batchId,
        serialId,
        reOrderCode,
        custAccount
    );
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createGetRegistratonDataInput(
    queryResultSettings: IQueryResultSettings,
    id: number,
    singleRecord: boolean
): IDataServiceRequest {
    const query = customControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetRegistratonData',
        true,
        DataServiceEntities.RegistratonDataEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRegistratonDataEntity' },
        { Id: id, SingleRecord: singleRecord }
    );
}

export function getRegistratonDataAsync(
    context: IContext,
    id: number,
    singleRecord: boolean
): AsyncResult<DataServiceEntities.IRegistratonDataEntity[]> {
    const request = createGetRegistratonDataInput(context.queryResultSettings || {}, id, singleRecord);
    return callActionOrExecute<DataServiceEntities.IRegistratonDataEntity[]>(request, context.callerContext);
}

export function createSendSubscriptionEmailInput(email: string, custAccount: string): IDataServiceRequest {
    const query = customControllerQuery();
    return query.createDataServiceRequestForOperation(
        'SendSubscriptionEmail',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { Email: email, CustAccount: custAccount }
    );
}

export function sendSubscriptionEmailAsync(context: IContext, email: string, custAccount: string): AsyncResult<boolean> {
    const request = createSendSubscriptionEmailInput(email, custAccount);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createGetSubscriptionDataInput(
    queryResultSettings: IQueryResultSettings,
    id: number,
    singleRecord: boolean
): IDataServiceRequest {
    const query = customControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSubscriptionData',
        true,
        DataServiceEntities.SubscriptionDataEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ISubscriptionDataEntity' },
        { Id: id, SingleRecord: singleRecord }
    );
}

export function getSubscriptionDataAsync(
    context: IContext,
    id: number,
    singleRecord: boolean
): AsyncResult<DataServiceEntities.ISubscriptionDataEntity[]> {
    const request = createGetSubscriptionDataInput(context.queryResultSettings || {}, id, singleRecord);
    return callActionOrExecute<DataServiceEntities.ISubscriptionDataEntity[]>(request, context.callerContext);
}
